/**
 * IncidentChat - Chat component for incident detail page in Worker App
 * 
 * Now uses the shared @crm/chat package for unified UI.
 */
import { ChatPanel } from "@crm/chat";

interface IncidentChatProps {
  incidentId: string;
  className?: string;
}

export function IncidentChat({ 
  incidentId, 
  className,
}: IncidentChatProps) {
  return (
    <ChatPanel
      ticketId={incidentId}
      className={className}
      variant="compact"
      collapsible={true}
      defaultExpanded={true}
    />
  );
}
